const customerEmailListFormatter = (data, dataKey) => {
  const dataSet = {};
  dataSet[dataKey] = data?.items ? JSON.parse(JSON.stringify(data?.items)) : data ? [JSON.parse(JSON.stringify(data))] : [];
  dataSet[dataKey].forEach((element) => {
    element["label"] = element["email_address"];
  });
  return dataSet;
};

export default customerEmailListFormatter;
